import { Heading, HeadingProps } from '@chakra-ui/react';
import React from 'react';

export const FormHeading = ({ children, ...rest }: HeadingProps) => {
  return (
    <Heading as="h6" size="md" fontWeight="500" my={4} {...rest}>
      {children}
    </Heading>
  );
};
